import { render, staticRenderFns } from "./StopServiceAccount.vue?vue&type=template&id=05c63990&scoped=true&"
import script from "./StopServiceAccount.vue?vue&type=script&lang=js&"
export * from "./StopServiceAccount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05c63990",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/bamboo/xml-data/build-dir/WWW-WWW-JOB1/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('05c63990')) {
      api.createRecord('05c63990', component.options)
    } else {
      api.reload('05c63990', component.options)
    }
    module.hot.accept("./StopServiceAccount.vue?vue&type=template&id=05c63990&scoped=true&", function () {
      api.rerender('05c63990', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/src/components/stopservice/StopServiceAccount.vue"
export default component.exports